export const ChartViewType = {
  SINGLE_MEMBER_SELECTION: 'SINGLE_MEMBER_SELECTION',
  MULTI_MEMBER_SELECTION: 'MULTI_MEMBER_SELECTION',
};

export const ChartType = {
  LINE: 'LINE',
  BAR: 'BAR',
  PIE: 'PIE',
  ROW: 'ROW',
  GAUGE: 'GAUGE',
};

export const CHART_DISPLAY_CONFIG = {
  SHOW_CHART_HEADER: false,
};

// Grid layout configuration — shared between editor, preview, and display.
// Doubling from 12→24 cols and 40→60 rows gives 2x finer positioning precision.
export const CHART_GRID_CONFIG = {
  BREAKPOINTS: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 } as const,
  COLS: { lg: 36, md: 30, sm: 18, xs: 12, xxs: 6 } as const,
  TOTAL_ROWS: 90,
  MARGIN: [10, 10] as [number, number],
  CONTAINER_PADDING: [10, 10] as [number, number],
};
